import { useState } from 'react';
import { ModalSubmitDialog } from '../../components/modalSubmitDialog.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    initialNotice: string | undefined;
    onSuccess: () => void;
    onClose: () => void;
}

export function NoticeDialog({
    initialNotice,
    onSuccess,
    onClose,
}: Props) {

    const [notice, setNotice] = useState(initialNotice ?? '');

    const mutateNotice = trpc.notice.set.useMutation();


    async function handleSubmit() {
        try {
            await mutateNotice.mutateAsync(notice);
            onSuccess();
            onClose();
        } catch (e) {
            console.log(e);
            alert('Failed to save');
        }
    }

    return (
        <ModalSubmitDialog
            isOpen={true}
            isSubmitting={mutateNotice.isPending}
            onSubmit={handleSubmit}
            onCancel={onClose}
        >
            <textarea
                style={{width: '600px', padding: '8px'}}
                value={notice}
                rows={10}
                onChange={(e) => setNotice(e.target.value)}
            />
        </ModalSubmitDialog>
    )
}
